module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-GB":{"update-api-token":"Update API Token","api-token-updated":"API Token updated","failed-update-api-token":"Failed to update API token","create-api-token":"Create API Token","api-token-created":"API Token created","failed-create-api-token":"Failed to create API token"}}')
  delete Component.options._Ctor
}
